module.exports = __webpack_public_path__ + "img/manage-service.a9246f97.svg";